import React, { FC, useState } from "react";
import { StoryType } from "data/types";
import { getEnvVariables } from '../../helpers/getEnvVariables';
import StoryVideo from "shared/StoryVideo/StoryVideo";
import StoryImg from "shared/StoryImg/StoryImg";
import NcModal from "shared/NcModal/NcModal";
import StoryPlayer from "components/StoryPlayer/StoryPlayer";

export interface StoryCardProps {
  className?: string;
  story: StoryType;
  stories: StoryType[];
}

const StoryCard: FC<StoryCardProps> = ({
  className = "",
  story,
  stories
}) => {
const { REACT_APP_URL } = getEnvVariables();
const [isOpen, setIsOpen] = useState(false);

  const { img,data, } = story;
  const placeholderImg = `${REACT_APP_URL}view/stories/${img[0].img}`;
  return (
    <NcModal
      modalTitle='Historias'
      isOpenProp={isOpen}
      onCloseModal={()=>setIsOpen(false)}
      renderTrigger={(openModal)=>(
      <>
       <div
        className={`flex-shrink-0 relative w-full aspect-w-5 aspect-h-4 sm:aspect-h-7 h-0 rounded-2xl overflow-hidden group`}
        onClick={()=>setIsOpen(true)}
      >
        {img[0].type==='imagen'?
          <StoryImg
          src={placeholderImg}
          userImage={data.img}
          className="object-cover w-full h-full rounded-2xl"
        />:
          <StoryVideo
            src={placeholderImg}
            userImage={data.img}
            className="object-cover w-full h-full rounded-2xl"
          />
        }
        <span className="opacity-0 group-hover:opacity-100 absolute inset-0 bg-black bg-opacity-10 transition-opacity"></span>
      </div>
      <div className="mt-4 truncate">
        <h2
          className={`text-sm sm:text-base text-neutral-900 dark:text-neutral-100 font-medium truncate`}
        >
          {data.name}
        </h2>
        
      </div>
      </>
     )}
      renderContent={()=>(
        <StoryPlayer storiesList={stories} setIsOpen={setIsOpen} startId={story.data._id}/>
     )}
     contentExtraClass="w-full sm:w-1/3 h-1/2"

    
     
      />
    
  );
};

export default StoryCard;
